import * as React from "react";

export const NoRecordIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7 7C7 5.34375 8.34375 4 10 4C11.6562 4 13 5.34375 13 7C13 8.33437 12.1281 9.46562 10.9219 9.85625C10.0344 10.1438 9 10.9594 9 12.25V13C9 13.5531 9.44688 14 10 14C10.5531 14 11 13.5531 11 13V12.25C11 12.1969 11.0188 12.1219 11.1094 12.0219C11.2031 11.9188 11.3563 11.8187 11.5375 11.7594C13.5469 11.1125 15 9.22813 15 7C15 4.2375 12.7625 2 10 2C7.2375 2 5 4.2375 5 7C5 7.55312 5.44687 8 6 8C6.55313 8 7 7.55312 7 7ZM10 18C10.6906 18 11.25 17.4406 11.25 16.75C11.25 16.0594 10.6906 15.5 10 15.5C9.30937 15.5 8.75 16.0594 8.75 16.75C8.75 17.4406 9.30937 18 10 18Z"
      fill="#66717C"
    />
  </svg>
);
